import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { AddService } from '../shared/services/userservices/add.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AttendanceService } from '../shared/services/attendanceservices/attendance.service';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from '../shared/services/shared-mode.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { MediaService } from '../shared/services/mediaservice/media.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { calculateUpdatedTime } from '../attendance/shift-time';
import { LeaveService } from '../shared/services/leaveservices/leave.service';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { flush } from '@angular/core/testing';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-attendance-management',
  templateUrl: './attendance-management.component.html',
  styleUrls: ['./attendance-management.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LoaderComponent, RouterModule, MatPaginatorModule],
  providers: [DatePipe],
  animations: [
    trigger('slideDown', [
      state('collapsed', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: '1',
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class AttendanceManagementComponent implements OnInit {
  @ViewChild('fileInput', { static: false }) fileInput?: ElementRef;
  public showSpinner = true;
  formData: FormData = new FormData();
  userAttendance: any[] = [];
  id: any;
  dateFilter: any;
  userId: any;
  arr: any = [];
  checkIn: any;
  attendanceForm!: FormGroup;
  selectedId: any;
  canEditShiftTimes = false;
  showShiftDetails = false;
  public user: any = [];
  selectedUsers: any[] = [];
  updatedby: any;
  nameFilter: any;
  attendanceidFilter: any;
  username: any;
  timeDifferenceHours: any;
  checkInTime: any;
  checkOutTime: any;
  attendanceType: any;
  Attendanceotificaton: any = {};
  attendcount: any = {};
  attendancecount: any = {};
  selectedFile: File | null = null;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  importedData: any[][] = [];
  selectedsheet: File | null = null;
  selectedDate: any;
  file: any;
  pagedData: any[] = [];
  pageSize = 50;
  currentPage = 0;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  startTimeLimit: any;
  totalhoursCheck: any;
  endTimeLimit: any;
  startdate: any;
  endDate: any;
  leaves: any;
  paidLeaves: any[] = [];
  unpaidLeaves: any[] = [];
  approveLeave: any;
  approvepaid = false;
  approveunpaid = false;
  todaycheck_in: any;
  todaycheck_out: any;
  offDay: any;
  filtertype: any;
  filterType: any;
  sortType = ''
  type: any;
  tracker_check: any;
  textColor: any;
  checkOutColor: any;
  empTrackerRecord: any;
  modalTrackerdate: any;
  modalName: any;
  modaltotalHours: any;
  modalcheckIn: any;
  modalcheckOut: any;
  isLoadingTrackerRecord = false;
  modalOverTime: any;
  selectedTrackerEntry: any = null;
  todayStr: any;
  sortdepartment = '';
  sort_by: any;
  sortBy = '';
  isFilterExpanded = false; // For expandable/collapsible filter section
  isCountExpanded = false;
  showUserStats = false;
  // your initial values
  startDateFilter: Date | null = new Date('2025-09-05');
  endDateFilter: Date | null = new Date('2025-09-05');
  @ViewChild('startPicker') startPicker!: ElementRef<HTMLInputElement>;
  @ViewChild('endPicker') endPicker!: ElementRef<HTMLInputElement>;
  departments: any;
  metadata: any;


  constructor(
    public router: Router,
    private http: HttpClient,
    public _location: Location,
    private addService: AddService,
    private attendanceservice: AttendanceService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private mediaService: MediaService,
    public datepipe: DatePipe,
    private leaveService: LeaveService,
    private fb: FormBuilder,


  ) {

    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.user = JSON.parse(localStorage.getItem('user') || ''),
      this.user_detail();

    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    const user_role = JSON.parse(this.user?.user_role?.user_roles)
    this.canEditShiftTimes = user_role?.role_type == 'Admin';

    this.attendanceForm = this.fb.group({
      check_in: [''],
      check_out: [''],
      total_hours: [''],
      overtime: [''],
      comments: ['', [Validators.required, Validators.minLength(50)]],
      shift_start_time: [''],
      shift_end_time: [''],
      total_working_hours: ['']
    });

    if (user_role?.role_type != "Admin" && user_role?.role_type != "Admin_AND_Team_Lead") {

      this.router.navigate(['/dashboard-1']);

    }


  }

  ngOnInit(): void {
    // this.getLeaves(false);
    // 

    this.Attendancenotificaton(this.attendancecount)
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.filterType = history.state;
    if ((this.filterType.type != '') && (this.filterType.type != undefined)) {
      this.attendanceFiter()
    } else {
      this.getUserAttendance();
    }


    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-based
    const day = String(today.getDate()).padStart(2, '0');

    this.todayStr = `${year}-${month}-${day}`;
    this.endDateFilter = this.todayStr;
    this.startDateFilter = this.todayStr;
    this.getData();
  }

  // Always show like "5 Sep 2025"
  formatDisplay(d: Date | null): string {
    return d ? (this.datePipe.transform(d, 'd MMM yyyy') ?? '') : '';
  }

  // Native input expects "yyyy-MM-dd"
  formatNative(d: Date | null): string {
    return d ? (this.datePipe.transform(d, 'yyyy-MM-dd') ?? '') : '';
  }

  parseDate(dateString: string): Date | null {
    if (!dateString) return null;
    // Handle "YYYY/MM/DD" format from API
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
      const day = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }

  openStartPicker() {
    const el = this.startPicker?.nativeElement;
    if (el?.showPicker) el.showPicker(); else el?.focus();
  }

  openEndPicker() {
    const el = this.endPicker?.nativeElement;
    if (el?.showPicker) el.showPicker(); else el?.focus();
  }

  applyStart(e: Event) {
    const val = (e.target as HTMLInputElement).value; // "yyyy-MM-dd"
    if (val) {
      const [year, month, day] = val.split('-').map(Number);
      this.startDateFilter = new Date(year, month - 1, day);
    } else {
      this.startDateFilter = null;
    }
  }

  applyEnd(e: Event) {
    const val = (e.target as HTMLInputElement).value;
    if (val) {
      const [year, month, day] = val.split('-').map(Number);
      this.endDateFilter = new Date(year, month - 1, day);
    } else {
      this.endDateFilter = null;
    }
  }

  // Toggle filter section expand/collapse
  toggleFilterSection() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }


  toggleCountSection() {
    this.isCountExpanded = !this.isCountExpanded;
  }

  onFilterChange() {
    // Call your API or filter logic here based on filterType
    // Example: this.getAllAttendance({ type: this.filterType });
    this.showSpinner = true;

    this.attendanceFiter()

  }








  CheckOutColor(data: any) {
  const record = data.data[0];
   if (this.Holidays(record) && this.Holidays(record).length > 0) {
    return '#4FDDAD';
  }
     if (data?.off_day == 1) {
          return '#4FDDAD';
        }
    if (!data.data[0].check_out) return 'black';
    if (data.data[0]?.user?.salary_type == 'hourly') {
      return '#4FDDAD'
    }
    this.endTimeLimit = data.data[0]?.shift_end_time;
    this.totalhoursCheck = Number(data.data[0]?.total_working_hours);
    if (data.data[0].source) {
        return (data.data[0].check_out < this.endTimeLimit && data.total_hours < this.totalhoursCheck)
        ? 'rgb(255, 183, 0)'
        : '#4FDDAD';
    } else {
      return (data.data[0].check_out < this.endTimeLimit && data.total_hours < this.totalhoursCheck)
        ? 'rgb(255, 183, 0)'
        : '#4FDDAD';
    }

  }


  CheckInColor(data: any) {
     // ✅ SECOND PRIORITY → Holiday
      const record = data.data[0];
   if (this.Holidays(record) && this.Holidays(record).length > 0) {
    return '#4FDDAD';
  }
     if (data?.off_day == 1) {
          return '#4FDDAD';
        }
    if (!data.data[0].check_in) return 'black';
    if (data.data[0]?.user?.salary_type == 'hourly') {
      return '#4FDDAD'
    }

    const start_time = data.data[0]?.shift_start_time; // "08:00"
    // Split hours and minutes

    // Return default color if shift_start_time is null or undefined
    if (!start_time) return '#4FDDAD';


    // Split hours and minutes
    const [hours, minutes] = start_time.split(':').map(Number);

    // Create a Date object (today's date, time from shift_start_time)
    const shiftDate = new Date();
    shiftDate.setHours(hours);
    shiftDate.setMinutes(minutes);
    shiftDate.setSeconds(0);
    shiftDate.setMilliseconds(0);

    // Add 75 minutes
    shiftDate.setMinutes(shiftDate.getMinutes() + 75);

    // Get the new time in HH:MM format
    const newTime = shiftDate.toTimeString().slice(0, 5);
    return data.data[0]?.check_in > newTime
      ? 'rgb(245, 149, 167)'
      : '#4FDDAD';

  }


  textColorCheck(data: any) {
    const record = data.data[0];
 if (this.Holidays(record) && this.Holidays(record).length > 0) {
    return '#4FDDAD';
  }
     if (data?.off_day == 1) {
          return '#4FDDAD';
        }
    if (!data.total_hours && data.total_hours == 0) {
      return 'black';
    }
    if (data.data[0]?.user?.salary_type == 'hourly') {
      return '#4FDDAD';
    }
    // ✅ Always green on holiday
    if (this.Holidays(record) !== undefined || this.isWeekend(record)) {
      return 'rgb(14, 153, 11)';
    }

    if (record.source === 'Tracker') {
      return data.total_hours >= (data?.data[0]?.total_working_hours )
        ? '#4FDDAD'
        : 'rgb(255, 183, 0)';
    } else {
      return data.total_hours >= data?.data[0]?.total_working_hours
        ? '#4FDDAD'
        : 'rgb(255, 183, 0)';
    }
  }
  trackerCheck(data: any) {
    if (data.data[0].source == 'Tracker') {

      this.tracker_check = data.total_hours > 0 && data.total_hours < (data.data[0].total_working_hours);
    } else {
      this.tracker_check = false;
    }
    return this.tracker_check;

  }



  onFileSelected(event: any) {
    this.file = event.target.files[0];
    if (this.file && this.isExcelFile(this.file)) {
      this.selectedsheet = this.file;
      const fileToUpload = event.target.files[0] as File;
      this.formData.append('file', fileToUpload, fileToUpload.name);
    } else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Only Excel File Accepted Here',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }
  isExcelFile(file: File): boolean {
    return file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
  }


  // refresh clear
  refreshRoute() {

    const currentState = history.state;
    if (currentState && currentState.type !== undefined) {
      history.replaceState({ ...currentState, type: undefined }, document.title);
    }

    window.location.reload();
  }

  navigateToBulkEdit() {
    this.router.navigate(['/bulk-attendance-edit']);
  }

  // Leave check
  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }
 
  getTrackerScreenShot(data: any) {
  // Filter only the entries where source is "Tracker"
  const trackerData = data.filter((entry: any) => entry.source === 'Tracker');

  if (!trackerData || trackerData.length === 0) {
    // No Tracker data found
    this.empTrackerRecord = null;
    this.showSpinner = false;
    return;
  }

  // Assuming you want the first Tracker entry if multiple exist
  const entry = trackerData[0];
  this.selectedTrackerEntry = entry;

  const _employmentId_trackerActivity = entry?.user?.employee_id_tracker_activity;
  const _date = entry.date;

  this.modalTrackerdate = _date;
  this.modalName = entry.user?.first_name + ' ' + entry.user?.last_name;
  this.modaltotalHours = entry.total_hours;
  this.modalcheckIn = entry.check_in;
  this.modalcheckOut = entry.check_out;
  this.modalOverTime = entry.overtime;

  if (_employmentId_trackerActivity) {
    this.isLoadingTrackerRecord = true;

    this.leaveService.getScreenShotTracker(_employmentId_trackerActivity, _date).then((res: any) => {
      this.empTrackerRecord = res.screenshots;
      this.isLoadingTrackerRecord = false;
    }).finally(() => {
      this.showSpinner = false;
    });
  } else {
    this.empTrackerRecord = null;
    this.showSpinner = false;
  }
}

  private formatBackfillDate(dateValue: any): string {
    if (!dateValue) return '';

    const parsedDate = new Date(dateValue);
    if (isNaN(parsedDate.getTime())) {
      return String(dateValue).replace(/-/g, '/');
    }

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  private closeTrackerModalBeforeConfirm(): Promise<void> {
    return new Promise((resolve) => {
      const trackerModal = document.getElementById('trackerViewModal') as HTMLElement | null;

      if (!trackerModal || !trackerModal.classList.contains('show')) {
        resolve();
        return;
      }

      let resolved = false;
      const done = () => {
        if (resolved) return;
        resolved = true;
        resolve();
      };

      // Preferred path when Bootstrap modal script is active.
      const onHidden = () => {
        done();
      };
      trackerModal.addEventListener('hidden.bs.modal', onHidden as EventListener, { once: true });

      const closeBtn = trackerModal.querySelector('.btn-close[data-dismiss="modal"]') as HTMLButtonElement | null;
      if (closeBtn) {
        closeBtn.click();
      } else {
        // Fallback for environments where Bootstrap JS/modal binding is not active.
        trackerModal.classList.remove('show');
        trackerModal.setAttribute('aria-hidden', 'true');
        trackerModal.style.display = 'none';
        document.body.classList.remove('modal-open');
        document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
      }

      // Safety net for local environments where hidden.bs.modal may not fire.
      setTimeout(done, 400);
    });
  }

  async confirmAndBackfillSingleUser(event?: Event) {
    event?.stopPropagation();
    await this.closeTrackerModalBeforeConfirm();

    const swalOnTopConfig: any = {
      target: document.body,
      heightAuto: false,
      backdrop: true,
      didOpen: () => {
        const container = document.querySelector('.swal2-container') as HTMLElement | null;
        if (container) {
          container.style.zIndex = '20000';
        }
      }
    };

    const selectedEntry = this.selectedTrackerEntry;
    const userId = selectedEntry?.user_id || selectedEntry?.user?.id;
    const attendanceDate = selectedEntry?.date || this.modalTrackerdate;

    if (!userId || !attendanceDate) {
      Swal.fire({
        ...swalOnTopConfig,
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Unable to identify user or date for refresh',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const confirmation = await Swal.fire({
      ...swalOnTopConfig,
      title: 'Refresh tracker data?',
      text: 'This will backfill tracker data for the selected user and date.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, refresh',
      cancelButtonText: 'Cancel'
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    this.showSpinner = true;
    const formattedDate = this.formatBackfillDate(attendanceDate);

    this.leaveService.backfillSingleUser(userId, formattedDate).then((response: any) => {
      if (response?.success) {
        Swal.fire({
          ...swalOnTopConfig,
          iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: response?.message || 'Tracker data refreshed successfully',
          showConfirmButton: false,
          timer: 3000,
        });

        this.getTrackerScreenShot([selectedEntry]);
      } else {
        Swal.fire({
          ...swalOnTopConfig,
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: response?.message || 'Unable to refresh tracker data',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      Swal.fire({
        ...swalOnTopConfig,
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Unable to refresh tracker data',
        showConfirmButton: false,
        timer: 3000,
      });
    }).finally(() => {
      this.showSpinner = false;
    });
  }

  fullscreenImageUrl: string | null = null;

  openFullscreen(imageUrl: string): void {
    this.fullscreenImageUrl = imageUrl;
  }

  closeFullscreen(): void {
    this.fullscreenImageUrl = null;
  }



  isPaidLeave(data: any) {
    const date = data.data[0]?.date;
    const userId = data.data[0]?.user_id;
    const attendanceCheckDate = this.datepipe.transform(new Date(date), 'yyyy-MM-dd');
    let found = false;
    this.paidLeaves.forEach((leave: any) => {
      if (leave.date == attendanceCheckDate && leave.userId == userId) {
        found = true;
        return;
      }
    });
    return found;
  }

  isUnpaidLeave(data: any) {
    const date = data.data[0]?.date;
    const userId = data.data[0]?.user_id;
    const attendanceCheckDate = this.datepipe.transform(new Date(date), 'yyyy-MM-dd');
    let found = false;
    this.unpaidLeaves.forEach((leave: any) => {
      if (leave.date == attendanceCheckDate && leave.userId == userId) {
        found = true;
        return;
      }
    });
    return found;
  }


  applyDataonAttandace() {
    this.showSpinner = false; // Assuming this is used for spinner display

    this.userAttendance.forEach((attendance: any) => {
      const date = attendance?.date;
      const attendanceCheckDate = this.datepipe.transform(new Date(date), 'yyyy-MM-dd');
      const userId = attendance?.user_id;

    });
  }









  uploadFile() {
    const date = this.selectedDate
    this.formData.append('date', date);
    this.formData.append('apicall', '1');
    this.showSpinner = true;
    this.dashboardService
      .upload(this.formData)
      .subscribe(response => {
        this.showSpinner = false;
        this.router.navigate(['/attendance-management']);
      },
        error => {
          this.showSpinner = false;
        }
      );
  }
  //


  onFileChange(event: any) {
    this.selectedFile = event.target.files[0];
  }



  reset() {
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
      this.selectedDate = null;
    }
  }





  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.user =  this.userInfo
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
    })

  }

  setupData() {
    const temp_array: any[] = []
    let indexCount = 0
    let lastDate = ""
    let lastUserID = 0
    let totalHours = 0
    let off_day = 0
    let singleArray: any[] = []
    for (const data of this.userAttendance) {
      if (indexCount == 0) {
        totalHours += data.total_hours ?? 0
        lastDate = data.date
        off_day = data.off_day
        lastUserID = data.user_id
        singleArray.push(data)
        if (indexCount == this.userAttendance.length - 1) {
          var obj = { "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day }
          temp_array.push(obj)
        }
      } else {
        if (data.date == lastDate && data.user_id == lastUserID) {
          totalHours += data.total_hours ?? 0
          singleArray.push(data)
          if (indexCount == this.userAttendance.length - 1) {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day }
            temp_array.push(obj)
          }
        } else {
          var obj = { "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day }
          temp_array.push(obj)
          singleArray = []
          lastDate = data.date
          lastUserID = data.user_id
          totalHours = 0
          off_day = data.off_day
          totalHours = data.total_hours ?? 0
          singleArray.push(data)
          if (indexCount == this.userAttendance.length - 1) {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day }
            temp_array.push(obj)
          }
        }
      }
      indexCount++
    }

    this.userAttendance = temp_array
    this.updatePagedData();
  }
  getUserAttendance() {
    this.showSpinner = true;
    const name = null;
    const formattedStartDate = null;
    const formattedEndDate = null;
    const attendanceid = null;
    this.attendanceservice.getAttendancefilter(name, formattedStartDate, formattedEndDate, attendanceid, this.type, this.sortdepartment, this.sort_by).then((value) => {
      this.userAttendance = value.data
      this.pagedData = this.userAttendance;
      this.metadata = value.meta;

      this.username = value?.data?.user
      // this.applyDataonAttandace();
      this.showSpinner = false;
      this.attendanceType = [];
      this.setupData();

    });
  }

  exportToExcel(): void {
    if (this.userAttendance.length != 0) {
      const exportData = this.userAttendance.map(data => ({
        'First Name': data.data[0].user.first_name,
        'Last Name': data.data[0].user.last_name,
        'Department': data.data[0].user.department,
        'Attendance ID': data.data[0].user.attendance_user_id,
        'Date': data.data[0].date,
        'Check In': data.data[0].check_in || 'Check-In Missing',
        'Check Out': data.data[0].check_out || 'Check-Out Missing',
        'Total Hours': data.data[0].total_hours || '0',
        'Overtime': data.data[0].overtime || '0',
        'Update Reason': data.data[0].update_reason || 'Not Updated',
        'Updated By': data.data[0].updated_by || 'Not Updated',
        'Is Weekend': this.isWeekend(data.data[0]) ? 'Yes' : 'No',
        'Is Holiday': data.data[0].isHoliday ? this.Holidays(data.data[0]) : 'No'
      }));

      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

      // Set column widths
      worksheet['!cols'] = [
        { wpx: 100 },  // First Name
        { wpx: 100 },  // Last Name
        { wpx: 100 },  // Date
        { wpx: 150 },  // Check In
        { wpx: 150 },  // Check Out
        { wpx: 100 },  // Total Hours
        { wpx: 100 },  // Overtime
        { wpx: 200 },  // Update Reason
        { wpx: 100 },  // Updated By
        { wpx: 150 },  // Updated At
        { wpx: 100 },  // Is Weekend
        { wpx: 200 }   // Is Holiday
      ];

      // Apply styles

      const workbook: XLSX.WorkBook = { Sheets: { 'User Attendance': worksheet }, SheetNames: ['User Attendance'] };
      XLSX.writeFile(workbook, 'UserAttendance.xlsx');
    } else {
      alert('No Attendance data available to export.');
    }
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePagedData();
  }

  // Method to update the paged data
  updatePagedData() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.pagedData = this.userAttendance.slice(startIndex, endIndex);
    this.offDay = this.pagedData
    this.showSpinner = false;
  }

  // // ✅ Weekend check (row specific, no shared variables)
  // isWeekend(data: any): boolean {
  //   const date = data.date;
  //   const dateObj = new Date(date);
  //   const dayOfWeek = dateObj.getDay(); // 0 = Sunday, 6 = Saturday

  //   const noCheckIn = !data.check_in;
  //   const noCheckOut = !data.check_out;

  //   // Weekend only applies if both check-in and check-out are empty
  //   return noCheckIn && noCheckOut && (dayOfWeek === 0 || dayOfWeek === 6);
  // }
  isWeekend(data: any): boolean {
    const date = data.date
    const dateObj = new Date(date);
    const dayOfWeek = dateObj.getDay(); // 0 for Sunday, 6 for Saturday
    this.todaycheck_in = data.check_in
    this.todaycheck_out = data.check_out
    // if ((data.check_in == null || data.check_in == undefined || data.check_in == "") && (data.check_out == null || data.check_out == undefined || data.check_out == "")) {
    //   return dayOfWeek === 0 || dayOfWeek === 6;
    // }
    // return false;

    const off_day = data.off_day == 1
    const noCheckIn = !data.check_in;
    const noCheckOut = !data.check_out;

    // Weekend only applies if both check-in and check-out are empty
    return noCheckIn && noCheckOut && (dayOfWeek === 0 || dayOfWeek === 6 || off_day);
  }
  Holidays(data: any) {
    const date = data.date;
    return this.dashboardService.otherOffDaysvalue[this.dashboardService.otherOffDays.indexOf(date)];
  }

  checkIsTracker(data: any): boolean {
    return data?.data?.some((item: any) => item?.source == 'Tracker') ?? false;
  }


  getStatus(data: any): string {
    const record = data?.data?.[0];
    if (!record) return "No Data";

    if (record?.user?.salary_type == 'hourly') {
      if (
        (!record.check_in || record.check_in === "") && (!record.check_out || record.check_out === "")
      ) {
        return "Skip Day";
      } else {
        return "All Good";
      }
    }
    if (record) {
      // ✅ Pre-joining check
      const joiningDateStr = record.user?.joining_date; // assuming joining_date exists
      const recordDate = new Date(record.date.replace(/\//g, "-"));

      if (joiningDateStr) {
        const joiningDate = new Date(joiningDateStr);
        if (recordDate < joiningDate) {

          return "Pre Joining";
        }
      }
      const lastWorkingDateStr = record.user?.last_working_date; // e.g., '2026-02-14'
      // ✅ Already Left
      if (lastWorkingDateStr) {
        const lastWorkingDate = new Date(lastWorkingDateStr);
        if (recordDate > lastWorkingDate) return "Post Leaving"; // new status
      }
    }




    if (this.Holidays(record) !== undefined && this.Holidays(record)) {
      const holidayTitle = this.Holidays(record);
      if (holidayTitle) {
        return holidayTitle;
      } else {
        return "Public Holiday";
      }
    }

    if (record.off_day === 1) {
      return "Off Day";
    }

    // leave cases

    debugger
    if (record.leave_id != null && record.leave_type == 'paid' && (record.leave_status === 'approved' || record.leave_status === 'recommended')) {
      return "Paid Leave";
    }
    if (record.leave_id != null && record.leave_type == 'unpaid' && (record.leave_status === 'approved' || record.leave_status === 'recommended')) {
      return "UnPaid Leave";
    }
    


    if (
      (!record.check_in || record.check_in === "") &&
      (!record.check_out || record.check_out === "")
    ) {
      return "Absent";
    }
    if (this.isWeekend(record)) {
      return "Weekend";
    }

    if (
      record.check_in &&
      record.check_in !== "" &&
      record.shift_start_time &&
      this.isCheckInLate(record.check_in, record.shift_start_time)
    ) {
      return "Punch In Late";
    }

    if (
      record.check_in &&
      record.check_in !== "" &&
      (!record.check_out || record.check_out === "") &&
      this.isShiftPassed(record.shift_end_time, record.date)
    ) {
      return "Punch Out Mis.";
    }

    if (
      (!record.check_in || record.check_in === "") &&
      (record.check_out && record.check_out !== "")
    ) {
      return "Punch In Mis.";
    }
    // 4. Short Hours
    // Use the aggregated total_hours from the grouped row (data.total_hours) so we don't mistakenly
    // compare the first row's total_hours when multiple records exist for a date.
    const totalHours = Number(data.total_hours ?? record.total_hours ?? 0);
    const expectedHours = Number(record.total_working_hours ?? record?.usershittime?.total_working_hours ?? 0);

    // If we don't have a reliable expected hours, skip this check
    if (expectedHours > 0 && totalHours > 0 && totalHours + 0.05 < expectedHours) {
      return "Short Hours";
    }

    if (this.isBothConditionsGreen(record) || (!this.trackerCheck(data) && record.check_out != null)) {
      return "All Good";
    }
    // fallback
    return "";
  }

  // Get multiple statuses (array) to display when user is absent + has pending leave
  getStatuses(data: any): string[] {
    const record = data?.data?.[0];
    const statuses: string[] = [];

    if (!record) return ["No Data"];

    const primaryStatus = this.getStatus(data);
    statuses.push(primaryStatus);

    // Check if user is absent (no check-in and check-out) AND has pending leave
    const isAbsent = (!record.check_in || record.check_in === "") && (!record.check_out || record.check_out === "");

    // Check if there's a pending leave (leave_status === 'pending' or 'applied')
    const hasPendingLeave = record.leave_id != null && (record.leave_status === 'pending' || record.leave_status === 'applied');


    if (isAbsent && hasPendingLeave) {
      // Add "Applied Leave" as second badge
      if (!statuses.includes("Applied Leave")) {
        statuses.push("Applied Leave");
      }
    }

    return statuses;
  }
  isCheckInLate(checkIn: string, shiftStart: string): boolean {
    if (!checkIn || !shiftStart) return false;

    // Convert "06.02" → "06:02"
    const normalizedCheckIn = checkIn.replace('.', ':');

    // Parse hours and minutes
    const [checkH, checkM] = normalizedCheckIn.split(':').map(Number);
    const [shiftH, shiftM] = shiftStart.split(':').map(Number);

    const checkMinutes = checkH * 60 + checkM;
    let shiftMinutes = shiftH * 60 + shiftM;

    // Add 45 minutes grace period
    shiftMinutes += 75;

    return checkMinutes > shiftMinutes;
  }


  select(data: any) {
    this.selectedId = data?.data[0]?.id
    this.showShiftDetails = false;
    this.attendanceForm.patchValue({
      check_in: data?.data[0]?.check_in ?? '',
      check_out: data?.data[0]?.check_out ?? '',
      total_hours: data?.data[0]?.total_hours ?? '',
      overtime: data?.data[0]?.overtime ?? '',
      comments: data?.data[0]?.update_reason ?? '',
      shift_start_time: this.normalizeTimeForInput(data?.data[0]?.shift_start_time),
      shift_end_time: this.normalizeTimeForInput(data?.data[0]?.shift_end_time),
      total_working_hours: data?.data[0]?.total_working_hours ?? ''
    });
  }

  toggleShiftDetails() {
    this.showShiftDetails = !this.showShiftDetails;
  }

  calculateWorkingHours() {
    const selectedCheckIn = this.attendanceForm.get('check_in')?.value;
    const selectedCheckOut = this.attendanceForm.get('check_out')?.value;

    if (selectedCheckIn && selectedCheckOut) {
      const [inH, inM] = selectedCheckIn.split(':').map(Number);
      const [outH, outM] = selectedCheckOut.split(':').map(Number);

      if (!isNaN(inH) && !isNaN(inM) && !isNaN(outH) && !isNaN(outM)) {
        const startMinutes = inH * 60 + inM;
        let endMinutes = outH * 60 + outM;

        // Handle overnight shift
        if (endMinutes < startMinutes) {
          endMinutes += 24 * 60;
        }

        const totalMinutes = endMinutes - startMinutes;
        const hours = totalMinutes / 60;
        this.attendanceForm.patchValue({ total_hours: parseFloat(hours.toFixed(2)) });
      } else {
        this.attendanceForm.patchValue({ total_hours: 0 });
      }
    }
  }

  private normalizeTimeForInput(value: any): string {
    if (!value) {
      return '';
    }
    return value.toString().substring(0, 5);
  }

  private formatTimeWithSeconds(value: any): string | null {
    if (!value) {
      return null;
    }
    return value.toString().length === 5 ? `${value}:00` : value;
  }

  updateAttendance() {
    if (this.attendanceForm.invalid) {
      this.attendanceForm.markAllAsTouched();
      return;
    }

    this.showSpinner = true;
    const formValue = this.attendanceForm.value;
    const payload: any = {
      id: this.selectedId,
      attendance_id: this.selectedId,
      check_in: formValue.check_in,
      check_out: formValue.check_out,
      total_hours: formValue.total_hours,
      overtime: formValue.overtime,
      comments: formValue.comments,
      reason: formValue.comments
    };

    if (this.canEditShiftTimes) {
      payload.shift_start_time = this.formatTimeWithSeconds(formValue.shift_start_time);
      payload.shift_end_time = this.formatTimeWithSeconds(formValue.shift_end_time);
      payload.total_working_hours = formValue.total_working_hours;
    }

    this.addService.updateAttendance(payload).then((value: any) => {
      this.showSpinner = false;

      if (value?.success == true) {
        const closeButton = document.getElementById('updateAttendanceCloseBtn') as HTMLButtonElement;
        closeButton?.click();

        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Attendance Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });

        this.getUserAttendance();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value?.message || 'Some errors in attendance update request',
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }).catch(() => {
      this.showSpinner = false;
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Some errors in attendance update request',
        showConfirmButton: false,
        timer: 3000,
      });
    });

  }

  attendanceFiter() {
    this.showSpinner = true;

    const hasSortType = !!this.sortType;
    const hasName = !!this.nameFilter;
    const hasAttendanceId = !!this.attendanceidFilter;
    const hasDate = !!this.startDateFilter || !!this.endDateFilter;
    const hasFilterType = !!this.filterType && !!this.filterType.type;

    /* ==========================
       Normalize Dates
    ========================== */
    if (hasDate) {
      if (!this.startDateFilter) this.startDateFilter = this.endDateFilter;
      if (!this.endDateFilter) this.endDateFilter = this.startDateFilter;

        if(this.startDateFilter != null && this.endDateFilter != null ){
        const sdate = new Date(this.startDateFilter);
        const edate = new Date(this.endDateFilter);

        // ✅ Validation: End date should NOT be less than Start date
        if (edate < sdate) {
          this.showSpinner = false;

          // Swal.fire({
          //   icon: 'error',
          //   title: 'Invalid Date Range',
          //   text: 'End date cannot be earlier than start date',
          //   confirmButtonText: 'OK'
          // });

            Swal.fire({
            iconHtml: '<img src="../../assets/images/error-modal.svg">',
            title: 'Invalid Date Range',
             text: 'End date cannot be earlier than start date',
             confirmButtonText: 'OK'
          });






          return; // ⛔ stop execution
        }
        }
       
    }

    if (hasFilterType) {
      this.type = this.filterType.type;

      this.attendanceservice.routefilter(this.type).then(value => {
        this.setData(value.data);
      });

      return;
    }

    /* ==========================
       2️⃣ Search / Date / ID
    ========================== */
    if (hasName || hasAttendanceId || hasDate || hasSortType) {

      const sdate = this.startDateFilter ? new Date(this.startDateFilter) : null;
      const edate = this.endDateFilter ? new Date(this.endDateFilter) : null;

      const formattedStartDate = sdate ? this.formatDate(sdate) : '';
      const formattedEndDate = edate ? this.formatDate(edate) : '';
      this.type = this.sortType;
      this.sort_by = this.sortBy

      this.attendanceservice
        .getAttendancefilter(
          this.nameFilter,
          formattedStartDate,
          formattedEndDate,
          this.attendanceidFilter,
          this.type,
          this.sortdepartment,
          this.sort_by
        )
        .then(value => {
          this.setData(value.data);
          this.metadata = value.meta;
          this.showUserStats = !!this.nameFilter && this.hasSingleUserResult(value.data);
        });

      return;
    }

    Swal.fire({
      iconHtml: '<img src="../../assets/images/error-modal.svg">',
      title: 'Enter Any Filter Value',
      showConfirmButton: false,
      timer: 2000,
    });


  }




  setData(data: any[]) {
    this.userAttendance = data;
    this.pagedData = data;
    this.setupData();

    this.pagedData.forEach(item => {
      this.offDay = item?.off_day;
    });

    this.showSpinner = false;
    this.showUserStats = this.nameFilter ? this.hasSingleUserResult(data) : false;
  }

  private getUniqueUserCount(data: any[]): number {
    if (!data || data.length === 0) {
      return 0;
    }

    const uniqueUsers = new Set<string>();

    data.forEach(item => {
      const user = item?.user ?? item?.data?.[0]?.user;
      if (user) {
        const identifier = user.id != null
          ? String(user.id)
          : user.attendance_user_id != null
            ? String(user.attendance_user_id)
            : `${user.first_name || ''} ${user.last_name || ''}`.trim();
        if (identifier) {
          uniqueUsers.add(identifier);
        }
        return;
      }

      if (item?.user_id != null) {
        uniqueUsers.add(String(item.user_id));
      }
    });

    return uniqueUsers.size;
  }

  private hasSingleUserResult(data: any[]): boolean {
    return this.getUniqueUserCount(data) === 1;
  }

 attendenceFilterPerUser30days(userData: any) {
    this.showSpinner = true;

    // Full name
    const singleUserName = userData.user.first_name + ' ' + userData.user.last_name;

    // ✅ End date = current date
    const endDate = new Date(); // use current date
    this.endDateFilter = endDate; // assign Date object

    // ✅ Start date = 31 days before current date
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 31);
    this.startDateFilter = startDate; // assign Date object

    // Format dates as strings for API call: "YYYY/MM/DD"
    const formatDate = (d: Date) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-based
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    };

    const startDateStr = formatDate(startDate);
    const endDateStr = formatDate(endDate);

    // Attendance ID
    const attendanceid = this.attendanceidFilter;

    // Call API
    this.attendanceservice
      .getAttendancefilter(
        singleUserName,
        startDateStr,
        endDateStr,
        attendanceid,
        this.type,
        this.sortdepartment,
        this.sort_by
      )
      .then((value) => {
        this.userAttendance = value.data;
        this.metadata = value.meta;
        this.pagedData = this.userAttendance;

        this.pagedData.forEach((item) => {
          this.offDay = item?.off_day;
        });

        this.showSpinner = false;
        this.setupData();
        this.showUserStats = true;
      });

    // Set name filter
    this.nameFilter = singleUserName;
}

  resetfilter() {
    this.showSpinner = true;
    this.showUserStats = false;

    this.nameFilter = '';
    this.attendanceidFilter = '';
    this.startDateFilter = this.todayStr;
    this.endDateFilter = this.todayStr;
    this.sortType = '';
    this.sortdepartment = '';
    this.sortBy = '';
    this.type = '';
    const dataFilter = null;
    this.attendanceservice.routefilter(dataFilter).then((value) => {
      this.userAttendance = value.data
      this.pagedData = this.userAttendance;
      this.pagedData.forEach(item => {
        this.offDay = item?.off_day;
      });
      this.setupData();

    });

    this.showSpinner = false;

  }


  formatDate(date: Date): string {
    if (date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;
    } else {
      return '';
    }
  }

  trimText() {
    const commentsControl = this.attendanceForm.get('comments');
    const value = commentsControl?.value ?? '';
    commentsControl?.setValue(value.replace(/\s+/g, ' ').trim());
  }


  //custimzing data colors
  data = {
    check_in: new Date('2023-11-01T10:00:00'), // Replace with your actual date and time
    check_out: new Date('2023-11-01T18:00:00') // Replace with your actual date and time
  };

  isBothConditionsTrue(data: any) {
    const checkInCheck = data.data[0]?.check_in == null || data.data[0]?.check_in == '';
    const checkOutCheck = data.data[0]?.check_out == null || data.data[0]?.check_out == '';
    return checkInCheck && checkOutCheck

  }

  isBothConditionsGreen(data: any): boolean {

    let starttime = data?.shift_start_time ?? data.usershittime?.start_time
    if (starttime == null || starttime == undefined) {
      starttime = '00:00'
    } else {
      starttime = calculateUpdatedTime(starttime)
    }
    this.startTimeLimit = starttime;
    this.endTimeLimit = data.shift_end_time ?? data.usershittime?.end_time
    // const checkInCondition = data.check_in < this.startTimeLimit;
    let checkInCondition;
    if (data?.check_in != null) {
      checkInCondition = (data.check_in < this.startTimeLimit);
    } else {
      checkInCondition = false;
    }
    const checkOutCondition = this.ismoreThan9Hours();
    // const totalHoursCondition = data.total_hours >= 9;

    let totalHoursCondition;


    if (data?.source == 'Tracker') {
      if (data?.total_hours != null || data?.total_hours != undefined) {
        totalHoursCondition = (data.total_hours >= (data.total_working_hours )) || (data.total_hours >= (data?.usershittime?.total_working_hours ));
      } else {
        totalHoursCondition = false;
      }
    } else {
      if (data?.total_hours != null || data?.total_hours != undefined) {
        totalHoursCondition = (data.total_hours >= data.total_working_hours) || (data.total_hours >= data?.usershittime?.total_working_hours);
      } else {
        totalHoursCondition = false;
      }
    }

    if (data?.usershittime?.total_working_hours == null || data?.usershittime?.total_working_hours == undefined) {
      this.totalhoursCheck = data.total_working_hours
    } else {
      this.totalhoursCheck = data?.usershittime?.total_working_hours
    }


    if (data?.usershittime?.off_day != null || data?.usershittime?.off_day != undefined) {
      if (data?.usershittime?.off_day == 1) {
        this.offDay = true;
      } else {
        this.offDay = false;
      }
    } else {
      this.offDay = false;

    }


    return checkInCondition && checkOutCondition && totalHoursCondition;
  }
  ismoreThan9Hours(): boolean {
    const checkInTime = new Date(this.data.check_in);
    const checkOutTime = new Date(this.data.check_out);
    const hoursDifference = (checkOutTime.getTime() - checkInTime.getTime()) / (1000 * 60 * 60); // Difference in hours
    return hoursDifference <= 8;
  }

  Attendancenotificaton(attendancecount: any) {
    const user_role = JSON.parse(this.user.user_role.user_roles)

    if (user_role.role_type != "Team_Lead") {
      this.attendcount = "attendance_request";

      this.addService.attendanceNotify(this.attendcount).then((value) => {

        this.Attendanceotificaton = value.data
      })
    }
  }


  isavailablefeature(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);

    switch (type) {
      case "isView":
        return user_role.attendance_data.data.values.view_attedance ?? false
      case "isSheet":
        return user_role.attendance_data.data.values.sheet ?? false
      case "isReport":
        return user_role.attendance_data.data.values.report ?? false
      case "isUpdate":
        return user_role.attendance_data.data.values.update ?? false

      default:
        return false;


    }
    return false
  }

  setattendance() {
    this.showSpinner = true;
    this.addService.attendanceset().then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 2000,
        });
        this.showSpinner = false;
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 2000,
        });
        this.showSpinner = false;
      }
      window.location.reload();

    })

  }


  isShiftPassed(shiftTime: string, shiftDate: string): boolean {
    if (!shiftTime) {
      return false; // no shift time → not passed
    }

    const now = new Date();

    // Parse shiftDate safely: "YYYY/MM/DD"
    const [year, month, day] = shiftDate.split(/[/-]/).map(Number);
    const shiftDateObj = new Date(year, month - 1, day); // month is 0-based

    // Parse shiftTime safely: "HH:mm"
    const [hours, minutes] = shiftTime.split(':').map(Number);
    shiftDateObj.setHours(hours, minutes, 0, 0);

    return now > shiftDateObj;

  }



  checkPaidLeave(data: any) {
    const date = data?.date;
    const userId = data?.user_id;
    const attendanceCheckDate = this.datepipe.transform(new Date(date), 'yyyy-MM-dd');
    let found = false;
    this.paidLeaves.forEach((leave: any) => {
      if (leave.date == attendanceCheckDate && leave.userId == userId) {
        found = true;
        return;
      }
    });
    return found;
  }

  checkUnpaidLeave(data: any) {
    const date = data?.date;
    const userId = data?.user_id;
    const attendanceCheckDate = this.datepipe.transform(new Date(date), 'yyyy-MM-dd');
    let found = false;
    this.unpaidLeaves.forEach((leave: any) => {
      if (leave.date == attendanceCheckDate && leave.userId == userId) {
        found = true;
        return;
      }
    });
    return found;
  }

  getData() {
    this.showSpinner = true;
    this.addService.getStaticData().then((value) => {
      this.showSpinner = false;
      this.departments = value.data.departments;

    });
  }




}


